// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__RzRNP","jpCurrentDate":"JP_Footer_jpCurrentDate__0vKWS","jpFootage":"JP_Footer_jpFootage__OPBrj","higlight":"JP_Footer_higlight__CBDCa"};